import { EditAction } from '../shared/enum/EditAction';
export interface KeywordModel {
    id: number,
    codeMetric?: number | null,
    description: string,
    active: boolean,
    editAction: EditAction
}
export const keywordModelInitial: KeywordModel = {
    id: 0,
    description: '',
    active: true,
    editAction: EditAction.NONE
};